import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShoppingBag } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
};

/**
 * Subtle "Recently Purchased" ticker — shows up on the homepage when at least
 * one purchase happened in the last 24h. Auto-rotates every 4 seconds.
 * Hides itself entirely when there's no recent activity (no AI-slop placeholders).
 */
const RecentPurchases = () => {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/api/payments/recent-purchases`)
      .then(({ data }) => {
        if (!cancelled && Array.isArray(data) && data.length > 0) setItems(data);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (items.length <= 1) return;
    const t = setInterval(() => {
      setIndex((p) => (p + 1) % items.length);
    }, 4000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;

  const item = items[index];

  return (
    <div
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8"
      data-testid="recent-purchases"
    >
      <div className="bg-[#0F0F0F] border border-[#262626] rounded-lg px-4 py-3 flex items-center gap-3 hover:border-[#D4AF37]/40 transition-colors">
        <ShoppingBag size={16} className="text-[#D4AF37] shrink-0" />
        <span className="text-[10px] tracking-[0.2em] uppercase text-[#737373] shrink-0 hidden sm:inline">
          Just Purchased
        </span>
        {item.cover_art_url && (
          <img
            src={item.cover_art_url}
            alt=""
            className="w-8 h-8 rounded object-cover shrink-0"
          />
        )}
        <span className="text-sm text-[#E5E5E5] truncate flex-1">
          Someone just picked up <strong className="text-white">{item.title}</strong>
        </span>
        <span className="text-xs text-[#A3A3A3] shrink-0">
          {timeAgo(item.purchased_at)}
        </span>
      </div>
    </div>
  );
};

export default RecentPurchases;
